import type { UIEvent } from 'react';

import { cart, user } from 'core';
import { SHIPPING_MODEL } from 'core/domains';
import { useShippingModelSelector } from 'core/use-cases/user/selectors';
import { RadioCard, RadioGroup, PickupStoreOption } from 'ui/components';

const PickupStoreOptionsWidget = () => {
  const { setDistributionCenter } = cart.commands.useCartCommand();
  const {
    shippingModel: { distributionCenterCode = 0 },
  } = cart.hooks.useCartShippingModel();

  const {
    data: { shippingModel = { availables: [] } },
  } = user.hooks.useUser();

  const { data, toggleActive } = useShippingModelSelector();
  const shippingModelData = toggleActive ? data : shippingModel;

  const searchInput = user.hooks.useUserSearchInput();

  const shippingModelPickupStore = shippingModelData?.availables?.find(
    (model) =>
      model.code === SHIPPING_MODEL.KEY_ACCOUNT_PICKUP_STORE ||
      model.code === SHIPPING_MODEL.PICKUP_STORE,
  );

  const pickupStoreOptions = shippingModelPickupStore?.deliveries || [];

  const optionsList = searchInput
    ? pickupStoreOptions.filter((option) =>
        option.address.toLowerCase().includes(searchInput.toLowerCase()),
      )
    : pickupStoreOptions;

  const handlePickupStore = (event: UIEvent) => {
    const selectedDistributionCenterCode = Number(event);

    return setDistributionCenter({
      address:
        pickupStoreOptions.find(
          (item) => item.distributionCenterCode === selectedDistributionCenterCode,
        )?.address || '',
      code: selectedDistributionCenterCode,
    });
  };

  return (
    <RadioGroup
      name="pickup-store-options"
      onChange={handlePickupStore}
      value={distributionCenterCode}
    >
      {optionsList?.map((option) => (
        <RadioCard key={option.distributionCenterCode} value={option.distributionCenterCode}>
          <PickupStoreOption title={option.address} />
        </RadioCard>
      ))}
    </RadioGroup>
  );
};

export default PickupStoreOptionsWidget;
